module.exports = __webpack_public_path__ + "static/media/symphony_logo_new_2021.802016b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/assets/images/symphony_logo_new_2021.png
// module id = 1450
// module chunks = 29